import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from '../../../services/subscription.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';
import { responseIsSuccess } from '../../../shared/helper-functions';
import { openModal, closeModal, closeModalWithoutRemovingBackdrop } from '../../../shared/modal-functions';
import { subscriptionViewSpanish } from '../subscription.static.data';

@Component({
  selector: 'app-manage-billing-address',
  templateUrl: './manage-billing-address.component.html',
  styleUrls: ['../../../app.component.css']  
})
export class ManageBillingAddressComponent implements OnInit {
  // Static Data
  subscriptionView: any;
  // Control view  
  openModal: any;
  closeModal: any;
  closeModalWithoutRemovingBackdrop: any;
  // Response data
  errorModalTitle: string;
  errorModalBody: string;
  // User data
  billingAddressToDelete: string;

  constructor(public subscriptionService: SubscriptionService, public googleAnalyticsService: GoogleAnalyticsService) { 
    this.subscriptionView = subscriptionViewSpanish;    
    this.openModal = openModal;
    this.closeModal = closeModal; 
    this.closeModalWithoutRemovingBackdrop = closeModalWithoutRemovingBackdrop;
  }

  ngOnInit() {
  }

  /*
   * Change billing address of the selected suscription
   */
  changeBillingAddress(billingAddress) {
    this.subscriptionService.changeBillingAddress(this.subscriptionService.selectedSubscription['PaymentMethodID'], billingAddress['CustAddrID']).subscribe(
      (response) => {
        if (responseIsSuccess(response)) {
          this.closeModal('#manageBillingAddressModal');
          this.subscriptionService.billingAddressToDisplay = billingAddress;
          this.subscriptionService.getBillingAddresses();
          this.openModal('#successChangeBillingAddressModal');
          this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Pantalla_Confirmar_Uso_Direccion');
        }
      },
      (error) => {
        this.openModal('#errorModal');
      });
  }

  /*
   * Remove a specific billing address
   */
  deleteBillingAddress() {
    this.subscriptionService.deleteBillingAddress(this.billingAddressToDelete).subscribe(
      (response) => {
        if (responseIsSuccess(response)) {
          this.closeModalWithoutRemovingBackdrop('#deleteAddressConfirmationModal');
          this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Pantalla_Validar_Eliminacion_Direccion_Facturacion');
        }
      },
      (error) => {
        this.closeModalWithoutRemovingBackdrop('#deleteAddressConfirmationModal');
        if (error.status === 702) { // trying to delete a billing address that is associated to a payment method
          this.openModal('#errorDeleteAddressModal');
          this.errorModalTitle = subscriptionViewSpanish.errorDeleteBillingAddressModal.title;
          this.errorModalBody = subscriptionViewSpanish.errorDeleteBillingAddressModal.body;
        } else if (error.status === 701) { // trying to delete the only address the customer has
          this.openModal('#errorDeleteAddressModal');
          this.errorModalTitle = subscriptionViewSpanish.errorDeleteLastBillingAddressModal.title;
          this.errorModalBody = subscriptionViewSpanish.errorDeleteLastBillingAddressModal.body;
        } else { // error with stored procedure
          this.openModal('#errorModal');
        }
      });
  }

  selectBillingAddress(address) {
    this.subscriptionService.selectedBillingAddress = address;
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/manage-billing-address/manage-billing-address.component.ts